
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"header.title":"Designer","load.exception.title":"Fehler","load.exception.message":"Das Laden der Einstellungen ist fehlgeschlagen.","no-active-view.message":"Bitte wählen Sie eine Sicht aus"},"en":{"header.title":"Designer","load.exception.title":"Error","load.exception.message":"Error loading settings.","no-active-view.message":"Please select a data view"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();